// extracted by mini-css-extract-plugin
module.exports = {"container":"Rv1DR","inner":"SaXZe","content":"_0EYFN","title":"_8r3k1","text":"v2XVl","main":"nG1ek","more":"_0zlHH","control":"HPr50","frame":"ZKvks","edge":"AL31A"};